import React from 'react';
import { CTAButton } from './CTAButton';
const metrics = [{
  value: '5',
  label: 'Volumi completi'
}, {
  value: '4',
  label: 'Bonus professionali'
}, {
  value: '504',
  label: 'Pagine pronte da stampare'
}, {
  value: '🌍',
  label: 'Disponibile in tutto il mondo'
}];
export function Hero() {
  return <section className="w-full bg-paper px-5 pb-12 pt-10 sm:pb-20 sm:pt-16" data-id="element-101" data-mp="4mi5rhhqm0hn">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-102" data-mp="1297ba1bnev89">
        <span className="mb-6 inline-block rounded-full border border-cobalt bg-cobalt/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-cobalt-deep" data-id="element-103" data-mp="xae9351taqne">
          RISORSE DIGITALI PRONTE ALL’USO PER INSEGNARE CHIMICA
        </span>

        <h1 className="font-serif-display text-[24px] font-bold leading-tight text-ink sm:text-5xl md:text-6xl" data-id="element-104" data-mp="nbewjbdxeav4">
          Il tuo intero percorso di chimica, organizzato e pronto da utilizzare in meno di 5 minuti.
        </h1>

        <figure className="relative mt-8 w-full max-w-[680px] sm:mt-10" data-id="element-105" data-mp="384js0vnybdrc">
          <div className="relative overflow-hidden rounded-[26px] bg-paper shadow-[0_20px_45px_-22px_rgba(31,36,48,0.28)]" data-id="element-106" data-mp="3j9u0ky5t7mla">
            <img src="https://cdn.magicpatterns.com/uploads/hGfysRVerdpNzfkhhfANVy/MOCKUP_QUIMICA_EN_ITALIANO.png" alt="Docente di chimica con la raccolta CHIMICA VISIVA™ e i cinque volumi del sistema didattico" width="1365" height="768" loading="eager" decoding="async" sizes="(max-width: 680px) calc(100vw - 40px), 680px" className="block aspect-[16/9] w-full object-cover" data-id="element-107" data-mp="3o5j3nbh1flmc" />
            <div className="pointer-events-none absolute inset-0 rounded-[26px] ring-1 ring-inset ring-white/45" aria-hidden="true" data-id="element-108" data-mp="2qhqvxnkct20i" />
          </div>
          <figcaption className="px-3 pt-3 text-center text-xs font-medium text-cobalt-deep/80" data-id="element-109" data-mp="2hjyn92950sm3">
            Progettato da una docente di chimica. Creato per la scuola reale.
          </figcaption>
        </figure>

        <p className="mt-6 max-w-xl text-[12px] text-ink/70 sm:text-base" data-id="element-110" data-mp="s3uqvwnx98am">
          Accedi a un sistema didattico digitale completo con schede teoriche visuali, attività
          operative, laboratori, verifiche equivalenti, soluzioni per il docente, giochi, progetti
          scientifici e strumenti di valutazione. Tutto è già organizzato per argomento, pronto da
          stampare e pensato per accompagnarti durante l’intero percorso scolastico.
        </p>

        <div className="mt-8 w-full max-w-md" data-id="element-111" data-mp="162c9jfyyzulo">
          <CTAButton label="ACCEDI ORA A CHIMICA VISIVA™" data-id="element-112" data-mp="112pz1eaj0sgk" />
          <p className="mt-3 text-xs text-ink/60 sm:text-sm" data-id="element-113" data-mp="110wnployxk28">
            Pagamento unico · Nessun abbonamento · Accesso digitale immediato
          </p>
          <p className="mt-1 text-xs text-ink/60 sm:text-sm" data-id="element-114" data-mp="3ltgmzq8oqqoc">
            Nessun costo mensile. Accesso senza scadenza.
          </p>
        </div>

        <div className="mt-7 grid w-full grid-cols-2 overflow-hidden rounded-2xl border border-cobalt/30 bg-white sm:mt-9 sm:grid-cols-4" data-id="element-115" data-mp="3hq26kygu48ad">
          {metrics.map((metric, index) => <div key={metric.label} className={`flex flex-col items-center px-4 py-5 sm:py-6 ${index % 2 !== 0 ? 'border-l border-cobalt/20' : ''} ${index >= 2 ? 'border-t border-cobalt/20' : ''} sm:border-l sm:border-t-0 sm:first:border-l-0`} data-id="element-116" data-mp="21bfulng27bte" data-mpi={index}>
              <span className="font-serif-display text-4xl font-bold text-cobalt" data-id="element-117" data-mp="2g1wvn5os7zpr">
                {metric.value}
              </span>
              <span className="mt-1 text-xs font-medium text-ink sm:text-sm" data-id="element-118" data-mp="2p0qpioaqabzm">{metric.label}</span>
            </div>)}
        </div>
      </div>
    </section>;
}